// 供应商管理
import api from '../../api'

const state = {
  supplierList: [],
  commodityList: [],
  supplierCodeList: []
}

const getters = {
  supplierList: state => state.supplierList,
  supplierCodeList: state => state.supplierCodeList
}

const actions = {
  getSupplierList ({ commit }) {
    return api.supplier.supplierList({
      pageNum: 1,
      pageSize: 1000
    })
      .then(res => {
        const records = res.data.records || []
        const list = []
        records.forEach(item => {
          list.push({
            value: item.id,
            label: item.name
          })
        })
        commit('updateSupplierList', list)
        return res
      })
  },

  getSupplierCode ({ commit }) {
    return api.supplier.supplierType()
      .then(res => {
        commit('updateSupplierCodeList', res.data)
        return res
      })
  }
}

const mutations = {
  updateSupplierList (state, payload) {
    state.supplierList = payload
  },
  updateSupplierCodeList (state, payload) {
    state.supplierCodeList = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
